import * as React from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { WorkAreasDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import LocationWorkAreas from 'modules/locations/components/WorkAreas'
import { useWorkAreas } from 'modules/locations/hooks/useWorkAreas'

const WorkAreasComponent = ({ children }: React.PropsWithChildren) => {
  const { locationId } = useOutletContext<{ locationId: string }>()

  const { navigation } = useNavigation()
  const {
    workAreas,
    loading: workAreasLoading,
    error: workAreasError,
  } = useWorkAreas({
    locationIds: [locationId],
  })
  const { data, loading: permissionsLoading, error: permissionsError } = useQuery(WorkAreasDocument)

  const unArchivedWorkAreas = workAreas.filter((workArea) => !workArea.archivedAt)
  const archivedWorkAreas = workAreas.filter((workArea) => workArea.archivedAt)
  const navigate = useNavigate()

  const addWorkArea = () => {
    track(trackingEvents.spaceControl.addWorkArea)
    navigate(navigation.settings.locations.locationsId.workAreas.add.fullPath({ id: locationId }))
  }

  const canManageWorkArea = data?.locations._policies.workAreaManage.can ?? false
  const canAddSpace = data?.spaceControl._policies.workSpaceCreate.can ?? false

  const loading = workAreasLoading || permissionsLoading
  const error = workAreasError || permissionsError

  return (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={error}
      widget={
        canManageWorkArea && (
          <Button onClick={addWorkArea}>
            {i18n.t('settings.locations.location.work_areas.add.button')}
          </Button>
        )
      }
    >
      {children}
      <LocationWorkAreas
        locationId={locationId}
        archivedWorkAreas={archivedWorkAreas}
        unArchivedWorkAreas={unArchivedWorkAreas}
        canManageWorkArea={canManageWorkArea}
        canAddSpace={canAddSpace}
      />
    </ResponsivePage.Body>
  )
}

export default WorkAreasComponent
